import React from 'react';
import { LegalDocumentPage } from './PrivacyPolicy';

const TermsOfService: React.FC = () => (
  <LegalDocumentPage title="Terms of Service" source="/terms-of-service.json" />
);

export default TermsOfService;
